import { CardModule } from 'primeng/card';
import { Component, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule, Location } from '@angular/common';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { DividerModule } from 'primeng/divider';
import { SelectModule } from 'primeng/select';
import { MessageService } from 'primeng/api';
import { Toast } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { LeadProfileMiddleScreenComponent } from 'src/app/private/components/leads/lead-profile-middle-screen/lead-profile-middle-screen.component';
import { LeadTimelineComponent } from 'src/app/private/components/leads/lead-timeline/lead-timeline.component';
import { LeadFollowupFormComponent } from 'src/app/private/components/leads/lead-followup-form/lead-followup-form.component';
import { AddNoteComponent } from 'src/app/private/components/leads/add-note/add-note.component';

import { ActivatedRoute } from '@angular/router';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { LeadService } from 'src/app/private/services/lead.service';
import { UsersService } from 'src/app/private/services/users.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { LeadActivityService } from 'src/app/private/services/micro-services/leadactivity.service';
import { RegistrationService } from 'src/app/private/services/registration.service';
import { catchError, forkJoin, of } from 'rxjs';
import { UploadService } from 'src/app/private/services/upload.service';
import { FeeService } from 'src/app/private/services/fee-service.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LeadCallComponent } from "../../leads/lead-call/lead-call.component";
import { LeadTaskComponent } from "../../leads/lead-task/lead-task.component";
import { LeadEmailComponent } from "../../leads/lead-email/lead-email.component";
import { LeadMeetingComponent } from "../../leads/lead-meeting/lead-meeting.component";
import { AdmissionProfileMiddleScreenComponent } from "../admission-profile-middle-screen/admission-profile-middle-screen.component";
import { AcademicYearService } from 'src/app/private/services/acedemicyear.service';
import { CourseService } from 'src/app/private/services/course.service';
import { BatchService } from 'src/app/private/services/batch.service';
import { AdmissionService } from 'src/app/private/services/admission.service';
import { HostelService } from 'src/app/private/services/hostel.service';
import { ScholarshipService } from 'src/app/private/services/scholarship.service';
import { TransportService } from 'src/app/private/services/transport.service';
@Component({
  selector: 'app-admission-profile',
  imports: [SharedModule, LeadCallComponent, LeadTaskComponent, LeadEmailComponent, LeadMeetingComponent, AddNoteComponent, LeadProfileMiddleScreenComponent, LeadTimelineComponent, LeadFollowupFormComponent, AdmissionProfileMiddleScreenComponent],
  templateUrl: './admission-profile.component.html',
  styleUrl: './admission-profile.component.scss'
})
export class AdmissionProfileComponent {

  selectedTabIdx = 0;
  admission_id: any = '';
  initialLoading = true;
  admissionDetails: any = {};
  users: any = [];
  fullUserList: any = [];
  allLeadFeilds: any = [];

  selectedOwner = '';
  selectedStatus = ''
  selectedRegistrationStatus = '';
  selectedApplicationStatus = '';
  selectedEnrollmentStatus = '';
  selectedType = '';
  selectedQueryType = '';
  selectedSource = '';
  loading = false;
  applicationOwner = '';
  leadActivity: any = [];
  editType: string | null = null;
  previewImage: string | null = null;

  selectedCourse: any = '';
  selectedAcademicYear: any = '';
  selectedAdmissionStatus: any = '';
  selectedBatch: any = '';
  selectedFeeCategory: any = '';
  lead_id: any = null;

  leadSources: any[] = [
    { label: 'Channel Partner', value: 'Channel Partner' },
    { label: 'Conference', value: 'Conference' },
    { label: 'Field Visit', value: 'Field Visit' },
    { label: 'Google', value: 'Google' },
    { label: 'Instagram', value: 'Instagram' },
    { label: 'Lead Gen Tools', value: 'Lead Gen Tools' },
    { label: 'Live Session', value: 'Live Session' },
    { label: 'Personal', value: 'Personal' },
    { label: 'Referral', value: 'Referral' },
    { label: 'LinkedIn', value: 'LinkedIn' },
    { label: 'Website', value: 'Website' },
    { label: 'WhatsApp', value: 'WhatsApp' },
    { label: 'Tina', value: 'Tina' },
    { label: 'Intern', value: 'Intern' },
    { label: 'Other', value: 'Other' }
  ];

  leadTypes: any[] = [
    { label: 'New Lead', value: 'New Lead' },
    { label: 'Cold Lead', value: 'Cold Lead' },
    { label: 'Warm Lead', value: 'Warm Lead' },
    { label: 'Hot Lead', value: 'Hot Lead' }
  ];

  leadStatusList: any[] = [
    { value: 'Assigned', label: 'Assigned' },
    { value: 'Working', label: 'Working' },
    { value: 'Qualified', label: 'Qualified' },
    { value: 'Raw', label: 'Raw' },
    { value: 'Unqualified', label: 'Unqualified' },
  ];


  registrationStatusList: any[] = [
    { value: 'Pending', label: 'Pending' },
    { value: 'Under Review', label: 'Under Review' },
    { value: 'Accepted', label: 'Accepted' },
    { value: 'Rejected', label: 'Rejected' }
  ];

  applicationStatusList: any[] = [
    { value: 'In Progress', label: 'In Progress' },
    { value: 'Completed', label: 'Completed' },
    { value: 'Canceled', label: 'Canceled' }
  ];

  enrollmentStatusList: any[] = [
    { value: 'Under Review', label: 'Under Review' },
    { value: 'In Progress', label: 'In Progress' },
    { value: 'Completed', label: 'Completed' },
    { value: 'Canceled', label: 'Canceled' }
  ];

  queryTypes: any[] = [
    { label: 'General', value: 'General' },
    { label: 'Admission', value: 'Admission' },
    { label: 'Application', value: 'Application' },
    { label: 'Fee Structure', value: 'Fee Structure' },
    { label: 'Registration', value: 'Registration' },
    { label: 'Placement', value: 'Placement' },
    { label: 'Alumni', value: 'Alumni' },
    { label: 'Course', value: 'Course' },
    { label: 'Other', value: 'Other' }
  ];

  allCourses: any[] = [];
  fullCourseList: any[] = [];
  paymentForList: any[] = [];
  feeCategoryList: any[] = [];
  batchList: any[] = [];
  admissionStatusList: any[] = [
    { value: 'Under Review', label: 'Under Review' },
    { value: 'Approved', label: 'Approved' },
    { value: 'Rejected', label: 'Rejected' },
    { value: 'Waitlisted', label: 'Waitlisted' },
  ];
  academicYearList: any[] = [];
  departmentList: any[] = [];

  hostelCategoryList: any[] = [];
  scholarshipTypeList: any[] = [];
  transportRouteList: any[] = [];

  constructor(private messageService: MessageService,
    private location: Location,
    private route: ActivatedRoute,
    private api: LeadService,
    private admissionApi: AdmissionService,
    private localStorage: LocalStorageService,
    private userApi: UsersService,
    private leadActivityService: LeadActivityService,
    private registrationApi: RegistrationService,
    private academicYearApi: AcademicYearService,
    private batchApi: BatchService,
    private courseApi: CourseService,
    private uploadService: UploadService,
    private feeGroupApi: FeeService,
    private hostelApi: HostelService,
    private scholarshipApi: ScholarshipService,
    private transportApi: TransportService,
  ) {
    this.admission_id = this.route.snapshot.paramMap.get('id');

    this.route.url.subscribe((segments) => {
      console.log('Segments:', segments);
      if (segments.length >= 2) {
        this.editType = segments[0].path; // 'registration' or 'leads'
      }
    });

    console.log('Edit Type:', this.editType);

  }

  ngOnInit() {
    this.getAdmissionDetails();
    this.getAllUsers();
    this.getAllCourses();

    this.getAllAdmissionYears();
    this.getAllBatches();
    this.getAllFeeCategories();
    this.getAllDepartments();

    this.getAllScholoarshipTypes();
    this.getAllHostelCategories();
    this.getAllTransportRoutes();

    // this.getLeadActivity();


    this.leadActivityService.leadActivity$.subscribe((leadActivity) => {
      this.leadActivity = leadActivity
    });
  }


  getAllAdmissionYears() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };

    this.academicYearApi.getAllAcademicYears(param).subscribe({
      next: (data) => {
        this.academicYearList = data;
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  getAllBatches() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };

    this.batchApi.getAllBatches(param).subscribe({
      next: (data) => {
        this.batchList = data;
      },
      error: (e) => {
        console.error(e);
      }
    });
  }

  getAllFeeCategories() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };

    this.feeGroupApi.getAllActiveFeeGroups(param).subscribe({
      next: (data) => {
        this.feeCategoryList = data;
      },
      error: (e) => {
        console.error(e);
      }
    });
  }

  getAllDepartments() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };

    this.userApi.getAllDepartment(param).subscribe({
      next: (data) => {
        this.departmentList = data;
      },
      error: (e) => {
        console.error(e);
      }
    });
  }

  getAllHostelCategories() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };

    this.hostelApi.getAllHostelCategories(param).subscribe({
      next: (data) => {
        this.hostelCategoryList = data;
      },
      error: (e) => {
        console.error(e);
      }
    });
  }

  getAllScholoarshipTypes() {

    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };

    this.scholarshipApi.getAllScholarships(param).subscribe({
      next: (data) => {
        this.scholarshipTypeList = data;
      },
      error: (e) => {
        console.error(e);
      }
    });
  }

  getAllTransportRoutes() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
      campus_id: this.localStorage.getCampusId()
    };

    this.transportApi.getAllTransports(param).subscribe({
      next: (data) => {
        this.transportRouteList = data;
      },
      error: (e) => {
        console.error(e);
      }
    });
  }




  getAllCourses() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
    };
    this.registrationApi.getAllCourses(param).subscribe({
      next: (data) => {
        this.allCourses = data || [];
        this.fullCourseList = data || [];
      },
      error: (e) => {
        console.error(e);
      },
    });
  }




  getAdmissionDetails(isUpdate = false) {

    this.api.getAdmission({
      admission_id: this.admission_id,
    }).subscribe({
      next: (response) => {
        console.log('Lead Details:', response);
        this.initialLoading = false;
        this.admissionDetails = response;

        console.log('Lead Details:', this.admissionDetails);

        this.selectedOwner = this.admissionDetails.assigned_to;
        this.selectedStatus = this.admissionDetails.lead_status;
        this.selectedType = this.admissionDetails.lead_type;
        this.selectedQueryType = this.admissionDetails.query_type;
        this.selectedSource = this.admissionDetails.source;
        this.selectedRegistrationStatus = this.admissionDetails.registration?.status;
        this.selectedApplicationStatus = this.admissionDetails.application_data?.status;
        this.applicationOwner = this.admissionDetails.application_data?.assign_to;
        this.selectedEnrollmentStatus = this.admissionDetails.enrollment_data?.enrollment_status;

        this.selectedCourse = this.admissionDetails.course_id;
        this.selectedAcademicYear = this.admissionDetails.academic_year_id;
        this.selectedBatch = this.admissionDetails.batch_id;
        this.selectedFeeCategory = this.admissionDetails.fee_group_id;
        this.selectedAdmissionStatus = this.admissionDetails.admission_status;


        this.lead_id = this.admissionDetails.lead_id;

        if (this.editType === 'enrollment') {
          this.selectedOwner = this.admissionDetails.enrollment_data?.assign_to;
        }

        if (isUpdate) {
          this.loading = false;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Lead Updated Successfully' });
        }

        console.log('Selected Owner:', this.selectedOwner);

      },
      error: (error) => {
        console.log('Error:', error);
        this.initialLoading = false;
      }
    }
    );

  }

  getAllUsers() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
    };
    this.userApi.findAllUsers(param).subscribe({
      next: (res: any) => {
        this.users = res || [];
        this.fullUserList = res || [];
        this.users = this.users.map((user: any) => {
          return {
            label: user.fname + " " + user.lname,
            value: user?.user_id
          };
        }
        );
      },
      error: (e: any) => {
        console.error(e);
      },
    });
  }



  getFullName() {
    let user = this.admissionDetails;
    return [user?.first_name, user?.last_name]
      .filter(name => !!name)
      .map(name => name.split(' ') // Split by space to handle multiple words
        .map((word: any) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ')) // Rejoin capitalized words
      .join(' ');
  }

  getName() {
    let user = this.admissionDetails;
    return [user?.first_name, user?.last_name]
      .filter(name => !!name)
      .join(' ');
  }

  updateData(data: any) {

    this.selectedStatus = data.lead_status;
    this.selectedType = data.lead_type;
    this.selectedQueryType = data.query_type;
    this.selectedSource = data.source;
    this.selectedRegistrationStatus = data.reg_data?.status;
    this.selectedApplicationStatus = data.application_data?.status;
    this.selectedEnrollmentStatus = data.enrollment_data?.enrollment_status;

    if (this.editType == 'enrollment') {
      this.selectedOwner = data.enrollment_data?.assign_to;
    } else {
      this.selectedOwner = data.assigned_to;
    }
  }


  handleSaveQuickActions() {

    const payload: any = {
      ...this.admissionDetails,
      old_admission_data: this.admissionDetails,
      assigned_to: this.selectedOwner,
      course_id: this.selectedCourse,
      academic_year_id: this.selectedAcademicYear,
      batch_id: this.selectedBatch,
      fee_group_id: this.selectedFeeCategory,
      admission_status: this.selectedAdmissionStatus,
      user_id: this.localStorage.getUserId()
    };

    this.loading = true;
    this.admissionApi.updateAdmission(payload).subscribe({
      next: (response) => {
        console.log('Update Lead:', response);
        this.getAdmissionDetails(true);
        this.leadActivityService.getAllLeadTimeLineActivity(this.lead_id);
      },
      error: (error) => {
        this.loading = false;
        console.log('Error:', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong' });
      }
    });

  }


  isAddNote = false;
  isEmailLead = false;
  isAddTask = false;
  isAddMeeting = false;
  isCallLead = false;

  handleCopy() {
    console.log('Copied');
    let email = this.admissionDetails.email;
    navigator.clipboard.writeText(email);
    this.messageService.add({ severity: 'success', summary: 'Email copied', detail: 'Email copied to clipboard' });
  }

  handleTabChange(event: any) {
    this.selectedTabIdx = event;
  }

  handleBack() {
    console.log('Back');
    this.location.back();
  }

  handleOpenNoteDialog() {
    this.isAddNote = true;
  }

  handleOpenEmailLead() {
    this.isEmailLead = true;
  }

  handleOpenMeetingDialog() {
    this.isAddMeeting = true;
  }

  handleOpenCallLead() {
    this.isCallLead = true;
  }

  handleOpenTaskDialog() {
    this.isAddTask = true;
  }

  handleCloseNoteDialog() {
    this.isAddNote = false;
  }

  handleCloseEmailDialog() {
    this.isEmailLead = false;
  }

  handleCloseTaskDialog() {
    this.isAddTask = false;
  }

  handleCloseMeetingDialog() {
    this.isAddMeeting = false;
  }

  handleCloseCallDialog() {
    this.isCallLead = false;
  }

  getInitials() {
    let name = this.getName();
    if (!name) {
      return "GR";
    }

    const initialName = name
      .split(' ')
      .filter(n => n && n.trim().length > 0) // Filter out empty or whitespace-only strings
      .map(n => n[0].toUpperCase())
      .join('');

    return initialName.length > 2 ? initialName.slice(0, 2) : initialName;
  }

  getLeadActivity() {
    this.leadActivityService.getAllLeadTimeLineActivity(this.lead_id);
  }

  async onProfileImageUpload(event: Event): Promise<any> {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files[0]) {
      const file = input.files[0];

      // Show image immediately using FileReader
      const reader = new FileReader();

      reader.onload = async (e: ProgressEvent<FileReader>) => {
        const result = e.target?.result;
        if (typeof result === 'string') {
          this.previewImage = result;

          this.messageService.add({
            severity: 'info',
            summary: 'Info',
            detail: 'Uploading Image...',
          });

          try {

            const imageUrl = await this.uploadToS3(file);

            const payload = {
              ...this.admissionDetails,
              profile_pic: imageUrl,
              // lead_id: this.lead_id,
              user_id: this.localStorage.getUserId(),
              old_admission_data: this.admissionDetails,
            };

            this.admissionApi.updateAdmission(payload).subscribe({
              next: (response) => {
                console.log('Profile Image Updated:', response);
                this.messageService.clear();
                this.messageService.add({
                  severity: 'success',
                  summary: 'Success',
                  detail: 'Profile Image Updated Successfully'
                });
                this.leadActivityService.getAllLeadTimeLineActivity(this.lead_id);
              },
              error: (error) => {
                console.error('Error:', error);
                this.messageService.clear('upload');
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: 'Something went wrong'
                });
              }
            });
          } catch (error) {
            console.error('Upload failed:', error);
            this.messageService.clear('upload');
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to upload image.'
            });
          }
        }
      };

      reader.readAsDataURL(file);
    }
  }

  async uploadToS3(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      const folder = `education/students/documents`;
      formData.append('file', file);
      formData.append('folders', folder);
      formData.append('bucket', 'global-upload-storage');

      this.uploadService.uploadDocuments(formData).subscribe({
        next: (response: any) => {
          console.log('File uploaded successfully:', response);
          resolve(response.url); // Assuming API returns { url: 's3-url' }
        },
        error: (error) => {
          console.error('Error uploading file:', error);
          reject('');
        },
      });
    });
  }


}
